import { useMemo } from 'react';
import { assembleLayer, getLayerTemplatesForConfig } from '../lib/templateEngine';
import {
  layer1Template,
  layer2Template,
  layer3Template,
  layer4Template,
} from '../data/projects/marveland';
import {
  deployModule,
  apiModule,
  typesModule,
  uiModule,
  pitfallsModule,
  packageManagerModule,
} from '../data/modules';
import type { ProjectConfig } from '../types';

const modules = new Map([
  ['deploy/cloudflare-worker-pages', deployModule],
  ['api/hono-kv-auth', apiModule],
  ['types/cms-common', typesModule],
  ['ui/react-vite-tailwind', uiModule],
  ['pitfalls/cloudflare-react', pitfallsModule],
  ['package-manager/pnpm-mandatory', packageManagerModule],
]);

const fallbackLayerTemplates = [layer1Template, layer2Template, layer3Template, layer4Template];

export interface LayerResult {
  content: string;
  unreplacedVariables: string[];
  moduleCount: number;
  variableCount: number;
}

export function useTemplateEngine(config: ProjectConfig): [LayerResult, LayerResult, LayerResult, LayerResult] {
  return useMemo(() => {
    const layerTemplates = getLayerTemplatesForConfig(config) ?? fallbackLayerTemplates;
    return layerTemplates.map((template, index) => {
      return assembleLayer({
        layer: (index + 1) as 1 | 2 | 3 | 4,
        projectConfig: config,
        template,
        modules,
      });
    }) as [LayerResult, LayerResult, LayerResult, LayerResult];
  }, [config]);
}
